export default __webpack_public_path__ + "static/realWorldImg2-065ed3d5f72351a0590d953c0ea8902a.webp";